// extracted by mini-css-extract-plugin
module.exports = {"margin":"Empty_margin__20Mqr","error":"Empty_error__1xuEK"};